"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageSize = void 0;
const get_manifest_1 = require("./get-manifest");
/**
 * Calculates the size of an image.
 *
 * OCI Distribution Specification endpoint: `/v2/<name>/manifests/<reference>`
 *
 * @returns Returns the size of an image in bytes.
 */
async function getImageSize(registryBase, repo, tag, username, password, options = {}, callChainObserver = { visitedUrls: [] }) {
    const manifest = await (0, get_manifest_1.getManifest)(registryBase, repo, tag, username, password, options, undefined, callChainObserver);
    const layers = manifest.layers || [];
    return layers.reduce((size, layerConfig) => size + layerConfig.size, 0);
}
exports.getImageSize = getImageSize;
//# sourceMappingURL=get-image-size.js.map